/**
 * Taken from this doc
 * https://docs.google.com/document/d/17ZQ0BaFiiOTj8shP6akgUdQuKXdKt8Ljm0u8leXJb-Y/edit
 */

export enum VenueGroup {
  OTHER = 'Other',
  GRIMALDI_FORUM = 'Grimaldi Forum',
  ONE_MONTE_CARLO = 'One Monte-Carlo',
  ESPACE_LEO_FERRE = 'Espace Léo Ferré',
  CHAPITEAU_DE_FONTVIEILLI_COLLECTION = 'Chapiteau de Fontvieille',
  // COLLECTION_DE_VOITURES_DE_SAS_LE_PRINCE_DE_MONACO = 'Collection de Voitures de SAS le Prince de Monaco',
  // MARCHE_DE_LA_CONDAMINE_HALL_DU_MARCHE = 'Marché de la Condamine -Halle du Marché',
  OCEANOGRAPHIC_MUSEUM_OF_MONACO = 'Musée océanographique de Monaco',
  HOTEL_HERMITAGE = 'Hotel Hermitage',
  MONTE_CARLO_SOSIETE_DES_BAINS_DE_MER = 'MONTE-CARLO SOCIÉTÉ DES BAINS DE MER',
  HOTEL_MONTE_CARLO_BAY = 'Hotel Monte Carlo Bay',
  HOTEL_MONTE_CARLO_BEACH = 'Hotel Monte Carlo Beach',
  FAIRMONT_MOTE_CARLO = 'Fairmont Monte Carlo',
  MERDIEN_BEACH_PLAZA = 'Meridien Beach Plaza',
}

export enum VenueName {
  OTHER = 'Other',

  //GRIMALDI_FORUM
  GRIMALDI_FORUM_SURF_TOTALE = 'Surface totale (Grimaldi Forum)',
  ESPLANADE_PRINCESSE_GRACE = 'Esplanade Princesse Grace',
  GTANDE_VERRIERE = 'Grande Verrière',
  SALLE_DES_PRINCES = 'Salle des Princes',
  SALLE_PRINCE_PIERRE = 'Salle Prince Pierre',
  SALLE_CAMILLE_BLANC = 'Salle Camille Blanc',
  ESPACE_RAVEL = 'Espace Ravel',
  ESPACE_DIAGHILEV = 'Espace Diaghilev',
  FOYERS_DE_AUDITORIUMS_PRINCE_PIERRE_ET__CAMILLE_BLANC = 'Foyers des auditoriums Prince Pierre et Camille Blanc',
  LE_GUELEFE = 'Le Guelfe (vue jardin)',
  LE_GENOIS = 'Le Génois (vue mer)',
  LINDIGO = 'L’Indigo',

  //ONE_MONTE_CARLO
  ONE_MONTE_CARLO_SURF_TOTALE = 'Surface totale (One Monte-Carlo)',
  SALLE_PELENIER = 'Salle plénière',
  SALLE_POLYVALENTE = 'Salle polyvalente',
  AUDITORIUM = 'Auditorium',
  SALLE_DE_SOUS_COMMISSION = 'Salle de sous-commission',
  FOYER = 'Foyer',

  //ESPACE_LEO_FERRE
  ESPACE_LEO_FERRE_SURF_TOTAL = 'Surface Totale (Espace Léo Ferré)',
  REZ_DE_CHAUSSEE = 'Rez-de-chaussée',

  //CHAPITEAU_DE_FONTVIEILLI_COLLECTION
  CHAPITEAU_DE_FONTVIEILLI_COLLECTION_SURFACE_TOTAL = 'Surface Totale (Chapiteau de Fontvieille)',
  ESPLANADE_EXTERIEURE = 'Esplanade extérieure',
  //OCEANOGRAPHIC_MUSEUM_OF_MONACO
  AQUARIUM = 'Aquarium',
  ODYSEE_DES_TORTUES = 'Odysée des tortues',
  SALLE_TORTUE = 'Salle tortue',
  SALLE_HIRONDELLE = 'Salle Hirondelle',
  SALLE_PRINCESSE_ALICE = 'Salle Princesse Alice',
  SALLE_DE_CONFERENCES = 'Salle de Conférences',
  SALON_DHONNEUR = `Salon d'Honneur`,
  OCEANONMANIA = 'Océanomania',
  ESPACE_MOSAIQUE = 'Espace Mosaique',
  ESPACE_MONACO_AND_L_OCEAN = `Espace Monaco & l'Océan`,
  SALLE_DE_LA_BELEINE = 'Salle de la Baleine',
  TERRASSE = 'Terrasse',

  //HOTEL_HERMITAGE
  SALON_AUGUSTE = 'SALON AUGUSTE',
  SALLE_BELLE_EPOQUE = 'SALLE BELLE ÉPOQUE',
  BELLE_EPOQUE_REGENCE_TERRASSE = 'BELLE EPOQUE + REGENCE + TERRASSE',
  TERRASSE_BELLE_EPOQUE = 'TERRASSE BELLE ÉPOQUE',
  SALON_BOUDERIE = 'SALON BOUDERIE',
  SALON_COSTA_1 = 'SALON COSTA 1',
  SALON_COSTA_2 = 'SALON COSTA 2',
  SALLE_EIFFEL = 'SALLE EIFFEL',
  SALON_EIFFEL_1 = 'SALON EIFFEL 1',
  SALON_EIFFEL_2 = 'SALON EIFFEL 2',
  SALON_EXCELSIOR_TERRASSE = 'SALON EXCELSIOR + TERRASSE',
  SALON_GUSTAVE = 'SALON GUSTAVE',
  SALON_GUSTAVE_1 = 'SALON GUSTAVE 1',
  SALON_GUSTAVE_2 = 'SALON GUSTAVE 2',
  SALON_GUSTAVE_3 = 'SALON GUSTAVE 3',
  FOYER_GUSTAVE = 'FOYER GUSTAVE',
  SALON_JARDIN_D_HIVER = 'SALON JARDIN D’HIVER',
  MEZZANINE_EIFFEL_TERRASSE = 'MEZZANINE EIFFEL + TERRASSE',
  TERRASSE_MIDI = 'TERRASSE MIDI',
  SALON_TRIANON = 'SALON TRIANON',
  VISTAMAR_SALON_PRIVE = 'VISTAMAR SALON PRIVÉ',

  //MONTE_CARLO_SOSIETE_DES_BAINS_DE_MER
  SALLE_DES_ETOILES = 'SALLE DES ÉTOILES',
  SALLE_DES_PALMIERS = 'SALLE DES PALMIERS',
  LE_DECK_TERRASSE = 'LE DECK + TERRASSE',
  SALLE_EMPIRE = 'SALLE EMPIRE',
  ATRIUM_CASINO = 'ATRIUM - CASINO',

  //HOTEL_MONTE_CARLO_BAY
  SALLE_AMERICA = 'SALLE AMERICA',
  SALLE_COLUMBIA = 'SALLE COLUMBIA',
  SALON_CAMBRIA = 'SALON CAMBRIA',
  SALON_CLEVER = 'SALON CLEVER',
  SALON_CREOLE = 'SALON CRÉOLE',
  SALON_MARIGOLD = 'SALON MARIGOLD',
  SALON_MARILEE = 'SALON MARILEE',
  SALON_MIKADO = 'SALON MIKADO',
  SALON_NIRVANA = 'SALON NIRVANA',
  SALON_NYALA = 'SALON NYALA',
  SALON_SINCERITY = 'SALON SINCERITY',
  SALON_SAMOURAI = 'SALON SAMOURAI',
  SALON_SINTRA = 'SALON SINTRA',
  SALON_TIRRENIA = 'SALON TIRRENIA',
  SALON_TRIVIA = 'SALON TRIVIA',
  SALON_TUIGA = 'SALON TUIGA',
  SALON_VIOLA = 'SALON VIOLA',
  SALON_VALIANT = 'SALON VALIANT',
  SALON_VANITY = 'SALON VANITY',
  BLUE_BAY_TERRASSE = 'BLUE BAY + TERRASSE',
  BLUE_GIN_TERRASSE = 'BLUE GIN + TERRASSE',
  LAS_BRISAS = 'LAS BRISAS',

  //HOTEL_MONTE_CARLO_BEACH
  // LE_DECK_TERRASSE = 'LE DECK + TERRASSE',
  SALON_EILEEN_GRAY = 'SALON EILEEN GRAY',
  RESTAURANT_ELSA_TERRASSE = 'RESTAURANT ELSA + TERRASSE',
  RESTAURANT_LA_PIZZERIA = 'RESTAURANT LA PIZZERIA',
  RESTAURANT_LA_VIGIE = 'RESTAURANT LA VIGIE',

  //FAIRMONT_MOTE_CARLO
  LE_GRAND_SALON = 'LE GRAND SALON',
  SALLE_D_OR_I_II = 'SALLE D’OR I + II',
  GALERIE_CRISTAL = 'GALERIE CRISTAL',
  SALLE_DE_LA_MER = 'SALLE DE LA MER',
  LE_PETIT_SALON = 'LE PETIT SALON',
  SALON_MISTRAU = 'SALON MISTRAU',
  GRAND_PRIX_A = 'GRAND PRIX A',
  GRAND_PRIX_B = 'GRAND PRIX B',
  SALON_LACOSTE = 'SALON LACOSTE',
  NAIADE_B = 'NAÏADE B',
  NAIADE_C = 'NAÏADE C',
  NAIADE_D = 'NAÏADE D',
  GRAND_PRIX_A_B = 'GRAND PRIX A + B',
  TERRASSE_PANORAMIQUE = 'TERRASSE PANORAMIQUE',
  BOARDROOM_3237 = 'BOARDROOM 3237',
  BOARDROOM_3239 = 'BOARDROOM 3239',
  HORIZON_ROOFTOP_DECK_TOP_DECK_AND_BORD_DE_MER = 'HORIZON ROOFTOP – DECK, TOP DECK & BORD DE MER',
  NAIADE_B_C_D = 'NAÏADE B+C+D',

  //MERDIEN_BEACH_PLAZA
  MEDITERRANEE_O_AND_E = 'MEDITERRANEE O & E',
  MEDITERRANNEE_E_OU_O = 'MEDITERRANNEE E OU O',
  HALL_O = 'HALL O',
  TERRASSE_MED = 'TERRASSE MED',
  ARCTIQUE = 'ARCTIQUE',
  ADRIATIQUE = 'ADRIATIQUE',
  BALTIQUE = 'BALTIQUE',
  EGEE = 'EGEE',
  PACIFIQUE = 'PACIFIQUE',
  HALL_1 = 'HALL 1',
  ATLANTIQUE_E_AND_M_AND_O = 'ATLANTIQUE E & M & O',
  ATLANTIQUE_E = 'ATLANTIQUE E',
  ATLANTIQUE_M = 'ATLANTIQUE M',
  ATLANTIQUE_O = 'ATLANTIQUE O',
  HALL_2 = 'HALL 2',
  TERRASSE_HALL_2 = 'TERRASSE HALL 2',
  MISTRAL = 'MISTRAL',
  TRAMONTANE = 'TRAMONTANE',
  SIROCCO_1_AND_2 = 'SIROCCO 1 & 2',
  SIROCCO_1_OU_2 = 'SIROCCO 1 OU 2',
  FOEHN = 'FOEHN',
  ZEPHYR = 'ZEPHYR',
  ALIZEE_1_AND_2 = 'ALIZEE 1 & 2',
  ALIZEE_1_OU_2 = 'ALIZEE 1 OU 2',
  BREVA = 'BREVA',
  HALL_4 = 'HALL 4',
  TERRASSE_5 = 'TERRASSE 5',
  INTEMPO_BRASSERIE = 'INTEMPO BRASSERIE',
  TERRASSE_INTEMPO = 'TERRASSE INTEMPO',
  INTEMPO_SALON = 'INTEMPO SALON',
  TERRASSE_SUPERIEURE = 'TERRASSE SUPERIEURE',
  TERRASSE_POOL_BEACH = 'TERRASSE POOL BEACH',
  TERRASSE_SOLARIUM = 'TERRASSE SOLARIUM',
  PLAGE = 'PLAGE',
  PISCINE = 'PISCINE',
  MUSE = 'MUSE',
}

const OTHER_OPTION = {
  name: VenueName.OTHER,
  m2Size: 0,
};

const GRIMALDI_FORUM_OPTIONS = [
  {
    name: VenueName.GRIMALDI_FORUM_SURF_TOTALE,
    m2Size: 35000,
  },
  {
    name: VenueName.ESPLANADE_PRINCESSE_GRACE,
    m2Size: 1700,
  },
  {
    name: VenueName.GTANDE_VERRIERE,
    m2Size: 1500,
  },
  {
    name: VenueName.SALLE_DES_PRINCES,
    m2Size: 1015,
  },
  {
    name: VenueName.SALLE_PRINCE_PIERRE,
    m2Size: 400,
  },
  {
    name: VenueName.SALLE_CAMILLE_BLANC,
    m2Size: 190,
  },
  {
    name: VenueName.ESPACE_RAVEL,
    m2Size: 4205,
  },
  {
    name: VenueName.ESPACE_DIAGHILEV,
    m2Size: 3216,
  },
  {
    name: VenueName.FOYERS_DE_AUDITORIUMS_PRINCE_PIERRE_ET__CAMILLE_BLANC,
    m2Size: 1460,
  },
  {
    name: VenueName.LE_GUELEFE,
    m2Size: 590,
  },
  {
    name: VenueName.LE_GENOIS,
    m2Size: 590,
  },
  {
    name: VenueName.LINDIGO,
    m2Size: 795,
  },
];
const ONE_MONTE_CARLO_OPTIONS = [
  {
    name: VenueName.ONE_MONTE_CARLO_SURF_TOTALE,
    m2Size: 1445,
  },
  {
    name: VenueName.SALLE_PELENIER,
    m2Size: 301,
  },
  {
    name: VenueName.SALLE_POLYVALENTE,
    m2Size: 178,
  },
  {
    name: VenueName.AUDITORIUM,
    m2Size: 154,
  },
  {
    name: VenueName.SALLE_DE_SOUS_COMMISSION,
    m2Size: 96,
  },
  {
    name: VenueName.FOYER,
    m2Size: 500,
  },
];
const ESPACE_LEO_FERRE_OPTIONS = [
  {
    name: VenueName.ESPACE_LEO_FERRE_SURF_TOTAL,
    m2Size: 2000,
  },
  {
    name: VenueName.REZ_DE_CHAUSSEE,
    m2Size: 1800,
  },
];
const CHAPITEAU_DE_FONTVIEILLI_COLLECTION_OPTIONS = [
  {
    name: VenueName.CHAPITEAU_DE_FONTVIEILLI_COLLECTION_SURFACE_TOTAL,
    m2Size: 2000,
  },
  {
    name: VenueName.ESPLANADE_EXTERIEURE,
    m2Size: 2500,
  },
];
const OCEANOGRAPHIC_MUSEUM_OF_MONACO_OPTIONS = [
  {
    name: VenueName.AQUARIUM,
    m2Size: 800,
  },
  {
    name: VenueName.ODYSEE_DES_TORTUES,
    m2Size: 600,
  },
  {
    name: VenueName.SALLE_TORTUE,
    m2Size: 100,
  },
  {
    name: VenueName.SALLE_HIRONDELLE,
    m2Size: 80,
  },
  {
    name: VenueName.SALLE_PRINCESSE_ALICE,
    m2Size: 42,
  },
  {
    name: VenueName.SALLE_DE_CONFERENCES,
    m2Size: 500,
  },
  {
    name: VenueName.SALON_DHONNEUR,
    m2Size: 300,
  },
  {
    name: VenueName.OCEANONMANIA,
    m2Size: 300,
  },
  {
    name: VenueName.ESPACE_MOSAIQUE,
    m2Size: 90,
  },
  {
    name: VenueName.ESPACE_MONACO_AND_L_OCEAN,
    m2Size: 500,
  },
  {
    name: VenueName.SALLE_DE_LA_BELEINE,
    m2Size: 500,
  },
  {
    name: VenueName.TERRASSE,
    m2Size: 500,
  },
];
const HOTEL_HERMITAGE_OPTIONS = [
  {
    name: VenueName.SALON_AUGUSTE,
    m2Size: 25,
  },
  {
    name: VenueName.SALLE_BELLE_EPOQUE,
    m2Size: 282,
  },
  {
    name: VenueName.BELLE_EPOQUE_REGENCE_TERRASSE,
    m2Size: 430,
  },
  {
    name: VenueName.TERRASSE_BELLE_EPOQUE,
    m2Size: 540,
  },
  {
    name: VenueName.SALON_BOUDERIE,
    m2Size: 14,
  },
  {
    name: VenueName.SALON_COSTA_1,
    m2Size: 30,
  },
  {
    name: VenueName.SALON_COSTA_2,
    m2Size: 20,
  },
  {
    name: VenueName.SALLE_EIFFEL,
    m2Size: 310,
  },
  {
    name: VenueName.SALON_EIFFEL_1,
    m2Size: 161,
  },
  {
    name: VenueName.SALON_EIFFEL_2,
    m2Size: 149,
  },
  {
    name: VenueName.SALON_EXCELSIOR_TERRASSE,
    m2Size: 102,
  },
  {
    name: VenueName.SALON_GUSTAVE,
    m2Size: 48,
  },
  {
    name: VenueName.SALON_GUSTAVE_1,
    m2Size: 16,
  },
  {
    name: VenueName.SALON_GUSTAVE_2,
    m2Size: 16,
  },
  {
    name: VenueName.SALON_GUSTAVE_3,
    m2Size: 16,
  },
  {
    name: VenueName.FOYER_GUSTAVE,
    m2Size: 119,
  },
  {
    name: VenueName.SALON_JARDIN_D_HIVER,
    m2Size: 44,
  },
  {
    name: VenueName.MEZZANINE_EIFFEL_TERRASSE,
    m2Size: 212,
  },
  {
    name: VenueName.TERRASSE_MIDI,
    m2Size: 475,
  },
  {
    name: VenueName.SALON_TRIANON,
    m2Size: 74,
  },
  {
    name: VenueName.VISTAMAR_SALON_PRIVE,
    m2Size: 27,
  },
];
const MONTE_CARLO_SOSIETE_DES_BAINS_DE_MER_OPTIONS = [
  {
    name: VenueName.SALLE_DES_ETOILES,
    m2Size: 973,
  },
  {
    name: VenueName.SALLE_DES_PALMIERS,
    m2Size: 590,
  },
  {
    name: VenueName.LE_DECK_TERRASSE,
    m2Size: 433,
  },
  {
    name: VenueName.SALLE_EMPIRE,
    m2Size: 500,
  },
  {
    name: VenueName.ATRIUM_CASINO,
    m2Size: 652,
  },
];
const HOTEL_MONTE_CARLO_BAY_OPTIONS = [
  {
    name: VenueName.SALLE_AMERICA,
    m2Size: 356,
  },
  {
    name: VenueName.SALLE_COLUMBIA,
    m2Size: 324,
  },
  {
    name: VenueName.SALON_CAMBRIA,
    m2Size: 83,
  },
  {
    name: VenueName.SALON_CLEVER,
    m2Size: 121,
  },
  {
    name: VenueName.SALON_CREOLE,
    m2Size: 120,
  },
  {
    name: VenueName.SALON_MARIGOLD,
    m2Size: 88,
  },
  {
    name: VenueName.SALON_MARILEE,
    m2Size: 47,
  },
  {
    name: VenueName.SALON_MIKADO,
    m2Size: 41,
  },
  {
    name: VenueName.SALON_NIRVANA,
    m2Size: 88,
  },
  {
    name: VenueName.SALON_NYALA,
    m2Size: 35,
  },
  {
    name: VenueName.SALON_SINCERITY,
    m2Size: 180,
  },
  {
    name: VenueName.SALON_SAMOURAI,
    m2Size: 68,
  },
  {
    name: VenueName.SALON_SINTRA,
    m2Size: 112,
  },
  {
    name: VenueName.SALON_TIRRENIA,
    m2Size: 38,
  },
  {
    name: VenueName.SALON_TRIVIA,
    m2Size: 60,
  },
  {
    name: VenueName.SALON_TUIGA,
    m2Size: 74,
  },
  {
    name: VenueName.SALON_VIOLA,
    m2Size: 96,
  },
  {
    name: VenueName.SALON_VALIANT,
    m2Size: 47,
  },
  {
    name: VenueName.SALON_VANITY,
    m2Size: 49,
  },
  {
    name: VenueName.BLUE_BAY_TERRASSE,
    m2Size: 598,
  },
  {
    name: VenueName.BLUE_GIN_TERRASSE,
    m2Size: 513,
  },
  {
    name: VenueName.LAS_BRISAS,
    m2Size: 116,
  },
];
const HOTEL_MONTE_CARLO_BEACH_OPTIONS = [
  {
    name: VenueName.LE_DECK_TERRASSE,
    m2Size: 433,
  },
  {
    name: VenueName.SALON_EILEEN_GRAY,
    m2Size: 70,
  },
  {
    name: VenueName.RESTAURANT_ELSA_TERRASSE,
    m2Size: 63,
  },
  {
    name: VenueName.RESTAURANT_LA_PIZZERIA,
    m2Size: 156,
  },
  {
    name: VenueName.RESTAURANT_LA_VIGIE,
    m2Size: 315,
  },
];
const FAIRMONT_MOTE_CARLO_OPTIONS = [
  {
    name: VenueName.LE_GRAND_SALON,
    m2Size: 1465,
  },
  {
    name: VenueName.SALLE_D_OR_I_II,
    m2Size: 1406,
  },
  {
    name: VenueName.GALERIE_CRISTAL,
    m2Size: 642,
  },
  {
    name: VenueName.SALLE_DE_LA_MER,
    m2Size: 425,
  },
  {
    name: VenueName.LE_PETIT_SALON,
    m2Size: 74,
  },
  {
    name: VenueName.SALON_MISTRAU,
    m2Size: 84,
  },
  {
    name: VenueName.GRAND_PRIX_A,
    m2Size: 140,
  },
  {
    name: VenueName.GRAND_PRIX_B,
    m2Size: 165,
  },
  {
    name: VenueName.SALON_LACOSTE,
    m2Size: 82,
  },
  {
    name: VenueName.NAIADE_B,
    m2Size: 46,
  },
  {
    name: VenueName.NAIADE_C,
    m2Size: 65,
  },
  {
    name: VenueName.NAIADE_D,
    m2Size: 62,
  },
  {
    name: VenueName.GRAND_PRIX_A_B,
    m2Size: 305,
  },
  {
    name: VenueName.TERRASSE_PANORAMIQUE,
    m2Size: 980,
  },
  {
    name: VenueName.BOARDROOM_3237,
    m2Size: 36,
  },
  {
    name: VenueName.BOARDROOM_3239,
    m2Size: 36,
  },
  {
    name: VenueName.HORIZON_ROOFTOP_DECK_TOP_DECK_AND_BORD_DE_MER,
    m2Size: 621,
  },
  {
    name: VenueName.NAIADE_B_C_D,
    m2Size: 173,
  },
];
const MERDIEN_BEACH_PLAZA_OPTIONS = [
  {
    name: VenueName.MEDITERRANEE_O_AND_E,
    m2Size: 549,
  },
  {
    name: VenueName.MEDITERRANNEE_E_OU_O,
    m2Size: 274,
  },
  {
    name: VenueName.HALL_O,
    m2Size: 230,
  },
  {
    name: VenueName.TERRASSE_MED,
    m2Size: 436,
  },
  {
    name: VenueName.ARCTIQUE,
    m2Size: 17,
  },
  {
    name: VenueName.ADRIATIQUE,
    m2Size: 54,
  },
  {
    name: VenueName.BALTIQUE,
    m2Size: 18,
  },
  {
    name: VenueName.EGEE,
    m2Size: 45,
  },
  {
    name: VenueName.PACIFIQUE,
    m2Size: 88,
  },
  {
    name: VenueName.HALL_1,
    m2Size: 90,
  },
  {
    name: VenueName.ATLANTIQUE_E_AND_M_AND_O,
    m2Size: 579,
  },
  {
    name: VenueName.ATLANTIQUE_E,
    m2Size: 158,
  },
  {
    name: VenueName.ATLANTIQUE_M,
    m2Size: 230,
  },
  {
    name: VenueName.ATLANTIQUE_O,
    m2Size: 191,
  },
  {
    name: VenueName.HALL_2,
    m2Size: 180,
  },
  {
    name: VenueName.TERRASSE_HALL_2,
    m2Size: 190,
  },
  {
    name: VenueName.MISTRAL,
    m2Size: 36,
  },
  {
    name: VenueName.TRAMONTANE,
    m2Size: 27,
  },
  {
    name: VenueName.SIROCCO_1_AND_2,
    m2Size: 56,
  },
  {
    name: VenueName.SIROCCO_1_OU_2,
    m2Size: 28,
  },
  {
    name: VenueName.FOEHN,
    m2Size: 26,
  },
  {
    name: VenueName.ZEPHYR,
    m2Size: 128,
  },
  {
    name: VenueName.ALIZEE_1_AND_2,
    m2Size: 69,
  },
  {
    name: VenueName.ALIZEE_1_OU_2,
    m2Size: 30,
  },
  {
    name: VenueName.BREVA,
    m2Size: 13,
  },
  {
    name: VenueName.HALL_4,
    m2Size: 180,
  },
  {
    name: VenueName.TERRASSE_5,
    m2Size: 1200,
  },
  {
    name: VenueName.INTEMPO_BRASSERIE,
    m2Size: 335,
  },
  {
    name: VenueName.TERRASSE_INTEMPO,
    m2Size: 380,
  },
  {
    name: VenueName.INTEMPO_SALON,
    m2Size: 66,
  },
  {
    name: VenueName.TERRASSE_SUPERIEURE,
    m2Size: 120,
  },
  {
    name: VenueName.TERRASSE_POOL_BEACH,
    m2Size: 200,
  },
  {
    name: VenueName.TERRASSE_SOLARIUM,
    m2Size: 160,
  },
  {
    name: VenueName.PLAGE,
    m2Size: 900,
  },
  {
    name: VenueName.PISCINE,
    m2Size: 544,
  },
  {
    name: VenueName.MUSE,
    m2Size: 440,
  },
];

export const venuesGroupsMap: Record<VenueGroup, Array<VenueName>> = {
  [VenueGroup.OTHER]: [VenueName.OTHER],
  [VenueGroup.GRIMALDI_FORUM]: [
    VenueName.GRIMALDI_FORUM_SURF_TOTALE,
    VenueName.ESPLANADE_PRINCESSE_GRACE,
    VenueName.GTANDE_VERRIERE,
    VenueName.SALLE_DES_PRINCES,
    VenueName.SALLE_PRINCE_PIERRE,
    VenueName.SALLE_CAMILLE_BLANC,
    VenueName.ESPACE_RAVEL,
    VenueName.ESPACE_DIAGHILEV,
    VenueName.FOYERS_DE_AUDITORIUMS_PRINCE_PIERRE_ET__CAMILLE_BLANC,
    VenueName.LE_GUELEFE,
    VenueName.LE_GENOIS,
    VenueName.LINDIGO,
  ],
  [VenueGroup.ONE_MONTE_CARLO]: [
    VenueName.ONE_MONTE_CARLO_SURF_TOTALE,
    VenueName.SALLE_PELENIER,
    VenueName.SALLE_POLYVALENTE,
    VenueName.AUDITORIUM,
    VenueName.SALLE_DE_SOUS_COMMISSION,
    VenueName.FOYER,
  ],
  [VenueGroup.ESPACE_LEO_FERRE]: [VenueName.ESPACE_LEO_FERRE_SURF_TOTAL, VenueName.REZ_DE_CHAUSSEE],
  [VenueGroup.CHAPITEAU_DE_FONTVIEILLI_COLLECTION]: [
    VenueName.CHAPITEAU_DE_FONTVIEILLI_COLLECTION_SURFACE_TOTAL,
    VenueName.ESPLANADE_EXTERIEURE,
  ],
  [VenueGroup.OCEANOGRAPHIC_MUSEUM_OF_MONACO]: [
    VenueName.AQUARIUM,
    VenueName.ODYSEE_DES_TORTUES,
    VenueName.SALLE_TORTUE,
    VenueName.SALLE_HIRONDELLE,
    VenueName.SALLE_PRINCESSE_ALICE,
    VenueName.SALLE_DE_CONFERENCES,
    VenueName.SALON_DHONNEUR,
    VenueName.OCEANONMANIA,
    VenueName.ESPACE_MOSAIQUE,
    VenueName.ESPACE_MONACO_AND_L_OCEAN,
    VenueName.SALLE_DE_LA_BELEINE,
    VenueName.TERRASSE,
  ],
  [VenueGroup.HOTEL_HERMITAGE]: [
    VenueName.SALON_AUGUSTE,
    VenueName.SALLE_BELLE_EPOQUE,
    VenueName.BELLE_EPOQUE_REGENCE_TERRASSE,
    VenueName.TERRASSE_BELLE_EPOQUE,
    VenueName.SALON_BOUDERIE,
    VenueName.SALON_COSTA_1,
    VenueName.SALON_COSTA_2,
    VenueName.SALLE_EIFFEL,
    VenueName.SALON_EIFFEL_1,
    VenueName.SALON_EIFFEL_2,
    VenueName.SALON_EXCELSIOR_TERRASSE,
    VenueName.SALON_GUSTAVE,
    VenueName.SALON_GUSTAVE_1,
    VenueName.SALON_GUSTAVE_2,
    VenueName.SALON_GUSTAVE_3,
    VenueName.FOYER_GUSTAVE,
    VenueName.SALON_JARDIN_D_HIVER,
    VenueName.MEZZANINE_EIFFEL_TERRASSE,
    VenueName.TERRASSE_MIDI,
    VenueName.SALON_TRIANON,
    VenueName.VISTAMAR_SALON_PRIVE,
  ],
  [VenueGroup.MONTE_CARLO_SOSIETE_DES_BAINS_DE_MER]: [
    VenueName.SALLE_DES_ETOILES,
    VenueName.SALLE_DES_PALMIERS,
    VenueName.LE_DECK_TERRASSE,
    VenueName.SALLE_EMPIRE,
    VenueName.ATRIUM_CASINO,
  ],
  [VenueGroup.HOTEL_MONTE_CARLO_BAY]: [
    VenueName.SALLE_AMERICA,
    VenueName.SALLE_COLUMBIA,
    VenueName.SALON_CAMBRIA,
    VenueName.SALON_CLEVER,
    VenueName.SALON_CREOLE,
    VenueName.SALON_MARIGOLD,
    VenueName.SALON_MARILEE,
    VenueName.SALON_MIKADO,
    VenueName.SALON_NIRVANA,
    VenueName.SALON_NYALA,
    VenueName.SALON_SINCERITY,
    VenueName.SALON_SAMOURAI,
    VenueName.SALON_SINTRA,
    VenueName.SALON_TIRRENIA,
    VenueName.SALON_TRIVIA,
    VenueName.SALON_TUIGA,
    VenueName.SALON_VIOLA,
    VenueName.SALON_VALIANT,
    VenueName.SALON_VANITY,
    VenueName.BLUE_BAY_TERRASSE,
    VenueName.BLUE_GIN_TERRASSE,
    VenueName.LAS_BRISAS,
  ],
  [VenueGroup.HOTEL_MONTE_CARLO_BEACH]: [
    VenueName.LE_DECK_TERRASSE,
    VenueName.SALON_EILEEN_GRAY,
    VenueName.RESTAURANT_ELSA_TERRASSE,
    VenueName.RESTAURANT_LA_PIZZERIA,
    VenueName.RESTAURANT_LA_VIGIE,
  ],
  [VenueGroup.FAIRMONT_MOTE_CARLO]: [
    VenueName.LE_GRAND_SALON,
    VenueName.SALLE_D_OR_I_II,
    VenueName.GALERIE_CRISTAL,
    VenueName.SALLE_DE_LA_MER,
    VenueName.LE_PETIT_SALON,
    VenueName.SALON_MISTRAU,
    VenueName.GRAND_PRIX_A,
    VenueName.GRAND_PRIX_B,
    VenueName.SALON_LACOSTE,
    VenueName.NAIADE_B,
    VenueName.NAIADE_C,
    VenueName.NAIADE_D,
    VenueName.GRAND_PRIX_A_B,
    VenueName.TERRASSE_PANORAMIQUE,
    VenueName.BOARDROOM_3237,
    VenueName.BOARDROOM_3239,
    VenueName.HORIZON_ROOFTOP_DECK_TOP_DECK_AND_BORD_DE_MER,
    VenueName.NAIADE_B_C_D,
  ],
  [VenueGroup.MERDIEN_BEACH_PLAZA]: [
    VenueName.MEDITERRANEE_O_AND_E,
    VenueName.MEDITERRANNEE_E_OU_O,
    VenueName.HALL_O,
    VenueName.TERRASSE_MED,
    VenueName.ARCTIQUE,
    VenueName.ADRIATIQUE,
    VenueName.BALTIQUE,
    VenueName.EGEE,
    VenueName.PACIFIQUE,
    VenueName.HALL_1,
    VenueName.ATLANTIQUE_E_AND_M_AND_O,
    VenueName.ATLANTIQUE_E,
    VenueName.ATLANTIQUE_M,
    VenueName.ATLANTIQUE_O,
    VenueName.HALL_2,
    VenueName.TERRASSE_HALL_2,
    VenueName.MISTRAL,
    VenueName.TRAMONTANE,
    VenueName.SIROCCO_1_AND_2,
    VenueName.SIROCCO_1_OU_2,
    VenueName.FOEHN,
    VenueName.ZEPHYR,
    VenueName.ALIZEE_1_AND_2,
    VenueName.ALIZEE_1_OU_2,
    VenueName.BREVA,
    VenueName.HALL_4,
    VenueName.TERRASSE_5,
    VenueName.INTEMPO_BRASSERIE,
    VenueName.TERRASSE_INTEMPO,
    VenueName.INTEMPO_SALON,
    VenueName.TERRASSE_SUPERIEURE,
    VenueName.TERRASSE_POOL_BEACH,
    VenueName.TERRASSE_SOLARIUM,
    VenueName.PLAGE,
    VenueName.PISCINE,
    VenueName.MUSE,
  ],
};

export const venues = [
  OTHER_OPTION,
  ...GRIMALDI_FORUM_OPTIONS,
  ...ONE_MONTE_CARLO_OPTIONS,
  ...ESPACE_LEO_FERRE_OPTIONS,
  ...CHAPITEAU_DE_FONTVIEILLI_COLLECTION_OPTIONS,
  ...OCEANOGRAPHIC_MUSEUM_OF_MONACO_OPTIONS,
  ...HOTEL_HERMITAGE_OPTIONS,
  ...MONTE_CARLO_SOSIETE_DES_BAINS_DE_MER_OPTIONS,
  ...HOTEL_MONTE_CARLO_BAY_OPTIONS,
  ...HOTEL_MONTE_CARLO_BEACH_OPTIONS,
  ...FAIRMONT_MOTE_CARLO_OPTIONS,
  ...MERDIEN_BEACH_PLAZA_OPTIONS,
];
